export default "__VITE_ASSET__4SVq1ioY__"